import React from "react";
import { getLocalStorage } from "@/helpers/common";
import { USER_INFO_KEY } from "@/constants/common";
import { useCurrentWebsite } from "@/hooks/useCurrentWebsite";
import { useMLSAgentAtGitchaRedirect } from "@/hooks/useMLSAgentAtGitchaRedirect";
import { trackEvent } from "@/services/analytics";
import { pageURLs } from "@/constants/pageURLs";
import "./GitchaMemberBridge.scss";

const GitchaMemberBridge = ({ slug, isSyndicated }) => {
  const { isGitchaDefaultWebsite } = useCurrentWebsite();
  const { redirectToBLSEnv, shouldRestrictAgent } =
    useMLSAgentAtGitchaRedirect();
  const sessionData = getLocalStorage(USER_INFO_KEY);
  const mls = sessionData?.userInfo?.mls;

  const isMember = shouldRestrictAgent && mls && mls !== "default";

  if (!isGitchaDefaultWebsite || !isSyndicated || !isMember) return null;

  return (
    <div className="gitcha-bridge gitcha-bridge--member">
      <p>
        You are a member of {mls.toUpperCase()}. Open this in your BLS to see
        matches and send an&nbsp;introduction.
      </p>
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => {
          trackEvent({
            name: "gitcha_member_bridge_clicked",
            attributes: { mls, slug },
          });
          redirectToBLSEnv({
            path: `${pageURLs.wantAdDetails}/${slug}`,
            onGitchaEnvFallback: null,
          });
        }}
      >
        Open in {mls.toUpperCase()}
      </button>
    </div>
  );
};

export default GitchaMemberBridge;
